module.exports = __webpack_public_path__ + "img/10.ca904bc1.svg";